import type { TRichMenuOperationConflict } from 'types'

const conflictCodes = new Set(['RICH_MENU_OPERATION_IN_PROGRESS'])

export function toRichMenuOperationConflict(
  caught: unknown,
): TRichMenuOperationConflict | undefined {
  if (
    typeof caught !== 'object' ||
    caught === null ||
    !('response' in caught)
  ) {
    return undefined
  }

  const response = caught.response
  if (
    typeof response !== 'object' ||
    response === null ||
    !('status' in response) ||
    response.status !== 409 ||
    !('data' in response)
  ) {
    return undefined
  }

  const data = response.data
  if (
    typeof data !== 'object' ||
    data === null ||
    !('code' in data) ||
    typeof data.code !== 'string' ||
    !conflictCodes.has(data.code)
  ) {
    return undefined
  }

  return data as TRichMenuOperationConflict
}
